<template>
  <b-container class="div-background" fluid>
    <b-breadcrumb :items="breadcrumbItems" class="minus-gutters"></b-breadcrumb>
    <h2>群組權限管理</h2>
    <b-button variant="success" v-b-modal.modal-1 class="mb-3"
      >新增群組</b-button
    >
    <b-table
      bordered
      id="my-table"
      :items="grouplist.items"
      :fields="grouplist.fields"
      striped
      outlined
      hover
    >
      <template v-slot:cell(edit)="data">
        <b-button-group>
          <b-button variant="primary" :to="link + data.item.group_AGID"
            >編輯</b-button
          >
        </b-button-group>
      </template>
    </b-table>
    <!-- <b-pagination
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="my-table"
            align="right"
        ></b-pagination> -->
    <b-modal
      id="modal-1"
      size="lg"
      title="群組設定"
      ok-title="確定變更"
      cancel-title="取消"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <b-form-group label="群組名稱：">
        <b-form-input
          v-model="grouplist.newgroup.group_name"
          type="text"
          required
        ></b-form-input>
      </b-form-group>
    </b-modal>
  </b-container>
</template>
<script>
export default {
  data() {
    return {
      link: "/GroupInfo/",
      breadcrumbItems: [
        {
          text: "首頁",
          href: "#",
        },
        {
          text: "帳號權限管理",
          active: true,
        },
        {
          text: "群組權限管理",
          active: true,
        },
      ],
      perPage: 3,
      currentPage: 1,
      grouplist: {
        newgroup: {
          group_name: null,
          group_PJID: null,
          group_AGID: null,
        },
        fields: [
          {
            key: "group_name",
            label: "群組名稱",
          },
          {
            key: "edit",
            label: "編輯",
          },
        ],
        items: [],
      },
      apiAccountGroupGetList: (data) =>
        this.userRequest.post("/API/Default/AccountGroupGetList", data),
      apiInsertAccountGroup: (data) =>
        this.userRequest.post("/API/Default/InsertAccountGroup", data),
    };
  },
  created() {
    this.checkLogin();
    //this.FunctionToken(this.getAccountGroupGetList, {})
    // this.checkPermission()
  },
  computed: {
    rows() {
      return this.grouplist.items.length;
    },
  },
  methods: {
    getAccountGroupGetList(data) {
      this.apiAccountGroupGetList(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          let jsonData = json.Data;
          if (json.Status) {
            this.mappingdata(JSON.parse(jsonData));
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    insertAccountGroup(data) {
      this.apiInsertAccountGroup(data)
        .then((res) => {
          const json = JSON.parse(res.data);
          let jsonData = JSON.parse(json.Data);
          if (json.Status) {
            this.$router.push("GroupInfo/" + jsonData.AG_ID);
            // this.grouplist.items.push(obj)
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    },
    mappingdata(data) {
      for (let i in data) {
        let obj = {
          group_AGID: i,
          group_name: data[i],
          group_PJID: null,
        };
        this.grouplist.items.push(obj);
      }
    },
    checkLogin() {
      let TokenID = sessionStorage.getItem("TokenID");
      if (TokenID) {
        this.checkPermission();
      } else {
        alert("無權限檢視此頁面，請登入帳號");
        this.$router.push({ path: "/login" });
      }
    },
    async checkPermission() {
      let data = { PJ_ID: "PJ000000000001", fun: this.checkByPJID };
      this.FunctionToken(this.Authority, data);
    },
    checkByPJID(value) {
      if (!value) {
        alert("無權限檢視此頁面，將返回首頁");
        this.$router.push({ path: "/" });
      } else {
        this.FunctionToken(this.getAccountGroupGetList, {});
      }
    },
    resetModal() {
      this.grouplist.newgroup.group_name = null;
    },
    handleOk() {
      if (this.IsNull(this.grouplist.newgroup.group_name) == "") {
        alert("請輸入名稱");
      } else {
        let obj = {
          AG_NAME: this.grouplist.newgroup.group_name,
        };
        this.FunctionToken(this.insertAccountGroup, obj);
      }
    },
  },
};
</script>
